"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Row = exports.Column = exports.GridContainer = void 0;

var _chunkB2edacfb = require("./chunk-b2edacfb.js");

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject3() {
  var data = (0, _chunkB2edacfb.a)(["\n  position: relative;\n  display: flex;\n  flex-flow: row nowrap;\n\n  width: 100%;\n  max-width: 1280px;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _chunkB2edacfb.a)(["\n  position: relative;\n  width: ", "%;\n  flex-basis: ", "%;\n  margin: 0 12px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _chunkB2edacfb.a)(["\n  position: relative;\n  display: flex;\n  flex-flow: row wrap;\n\n  margin: 0 auto;\n\n  width: 100%;\n  max-width: 1220px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var GridContainer = _styledComponents.default.section.withConfig({
  displayName: "grid__GridContainer",
  componentId: "sc-18g3gbi-0"
})(_templateObject());

exports.GridContainer = GridContainer;

var Column = _styledComponents.default.div.withConfig({
  displayName: "grid__Column",
  componentId: "sc-18g3gbi-1"
})(_templateObject2(), function (props) {
  return (props.size ? props.size : 1) / 12 * 100;
}, function (props) {
  return (props.size ? props.size : 1) / 12 * 100;
});

exports.Column = Column;

var Row = _styledComponents.default.div.withConfig({
  displayName: "grid__Row",
  componentId: "sc-18g3gbi-2"
})(_templateObject3());

exports.Row = Row;